var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "header-cart site-header__toggle",
      attrs: { href: _vm.cartlink }
    },
    [
      _vm.ordertype == "offer"
        ? _c(
            "span",
            {
              staticClass: "header-cart__price",
              class: { "header-cart__price--not-empty": _vm.subtotal > 0 }
            },
            [
              _vm._v("Tarjous\n    "),
              _vm.subtotal > 0
                ? _c("span", { staticClass: "header-cart__price-amount" }, [
                    _vm._v("WC-" + _vm._s(_vm.offerId))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.subtotal > 0
                ? _c(
                    "span",
                    { staticClass: "header-cart__tax tax" },
                    [
                      _c("price", {
                        attrs: {
                          "price-with-tax": _vm.subTotalWithTax,
                          "price-without-tax": _vm.subTotalWithoutTax
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _c(
            "span",
            {
              staticClass: "header-cart__price",
              class: { "header-cart__price--not-empty": _vm.subtotal > 0 }
            },
            [
              _vm._v(_vm._s(_vm.$modeoL10n.cart) + "\n    "),
              _vm.subtotal > 0
                ? _c(
                    "span",
                    { staticClass: "header-cart__price-amount" },
                    [
                      _c("price", {
                        attrs: {
                          "price-with-tax": _vm.subTotalWithTax,
                          "price-without-tax": _vm.subTotalWithoutTax
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.subtotal > 0
                ? _c("span", { staticClass: "header-cart__tax tax" }, [
                    _vm._v(
                      _vm._s(_vm.$modeoL10n.vat) +
                        " " +
                        _vm._s(_vm.$store.getters.displayVat)
                    )
                  ])
                : _vm._e()
            ]
          ),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "header-cart__amount" },
        [_vm.items > 0 ? [_vm._v(_vm._s(_vm.items))] : [_vm._v(" ")]],
        2
      ),
      _vm._v(" "),
      _c("span", { staticClass: "site-header__toggle__text" }, [
        _vm._v(_vm._s(_vm.$modeoL10n.cart))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fbe6040", { render: render, staticRenderFns: staticRenderFns })
  }
}